import { createFileRoute, Outlet } from "@tanstack/react-router"

// this is for breadcrumbs

export const Route = createFileRoute("/app/contracts/approvals")({
  component: Outlet,
  beforeLoad: (ctx) => ({ getTitle: () => ctx.context.t("ContractApprovals") }),
})
